import React, { useEffect } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { useTooltip } from './context';

export default function TooltipTrigger({ className = '', children = null }) {
  const { id, onMount } = useTooltip();

  useEffect(() => {
    onMount();
  }, [onMount]);

  return (
    <div id={id} className={cn(styles.trigger, className)}>
      {children}
    </div>
  );
}
